module.exports = __webpack_public_path__ + "img/Screenshot_2021-10-28-16-20-32-038_com.pinkcoffee.sexbattle.fc1830af.jpg";